import { assertFileName } from './documents/file-types.js';
import { DomainError } from './errors.js';
import { sniffAttachmentType } from './pms/attachments.js';

/**
 * Personelin sertifika ve kontrat dosyaları (04.11 notları B5, B6; ADR 0164). Saf kurallar: I/O
 * yok. Dosya değiştirilemez bir sürüm satırıdır; yeni dosya eskisini silmez.
 */

/** Dosya başına en çok 10 MB (sahip kararı 2026-11-04). */
export const CREW_FILE_MAX_BYTES = 10 * 1024 * 1024;

/** Kabul edilen türler: PDF, JPEG, PNG (sahip kararı 2026-11-04). */
export const CREW_FILE_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'] as const;
export type CrewFileMimeType = (typeof CREW_FILE_MIME_TYPES)[number];

/**
 * Türü içerikten belirler (istemcinin bildirdiği tür ve dosya adı güvenilmez; K15 emsali): PDF
 * `%PDF-`, JPEG `FF D8 FF`, PNG imzası. Başka tür `null`.
 */
export function sniffCrewFileType(head: Uint8Array): CrewFileMimeType | null {
  return sniffAttachmentType(head);
}

export interface CrewFileInput {
  name: string;
  size: number;
  mimeType: string;
  sha256: string;
}

const SHA256 = /^[0-9a-f]{64}$/;

/**
 * Dosyanın biçimi: ad (`assertFileName`), 1 bayt–10 MB (`FILE_TOO_LARGE`), tür listede
 * (`FILE_TYPE_MISMATCH`), SHA-256 64 küçük hex.
 */
export function parseCrewFile(input: CrewFileInput): CrewFileInput {
  assertFileName(input.name);
  if (!Number.isInteger(input.size) || input.size <= 0 || input.size > CREW_FILE_MAX_BYTES) {
    throw new DomainError('FILE_TOO_LARGE', String(input.size));
  }
  if (!(CREW_FILE_MIME_TYPES as readonly string[]).includes(input.mimeType)) {
    throw new DomainError('FILE_TYPE_MISMATCH', input.mimeType);
  }
  if (!SHA256.test(input.sha256)) throw new DomainError('VALIDATION_FAILED', 'sha256', 'sha256');
  return input;
}
